<template>
  <bs-box-panel showRightButton @on-right="getMore" title="环境监测">
    <div
      class="sn-bs-wrapper"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <div class="sn-bs-wrapper__sensor" v-if="!loading && sensorList.length">
        <el-carousel
          indicator-position="outside"
          arrow="never"
          :autoplay="carouselAutoplay"
        >
          <el-carousel-item v-for="i in carouselItemLength" :key="i">
            <div
              class="sn-bs-wrapper__sensor-block"
              v-for="(item, index) in sensorList.slice((i - 1) * 6, i * 6)"
              :key="index"
            >
              <img
                class="sn-bs-wrapper__img"
                :style="{
                  background: item.colorList
                    ? item.colorList
                    : colorList[index],
                }"
                :src="item.metricIcon"
                alt=""
              />
              <div class="sn-bs-wrapper__div">
                <el-tooltip
                  effect="dark"
                  :content="item.devicePropertyName"
                  :open-delay="500"
                  placement="top"
                  :visible-arrow="false"
                >
                  <div class="sn-bs-wrapper__div-name">
                    {{ item.devicePropertyName }}
                  </div>
                </el-tooltip>
                <div class="sn-bs-wrapper__div-unit">
                  {{ item.value ? item.value : "--" }}{{ item.unit }}
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <empty v-if="!loading && !sensorList.length"></empty>
    </div>
  </bs-box-panel>
</template>

<script>
import { iotAccess, iotAccessThird } from "@/api/request/snkd.produce";
import { mapState } from "vuex";
import Empty from "@/components/bs/BsBoxPanel/Empty";
import BsBoxPanel from "@/components/bs/BsBoxPanel";

export default {
  name: "EnvironmentalMonitoring",
  data() {
    return {
      loading: false,
      carouselAutoplay: false,
      deviceId: null,
      sensorList: [],
      thirdID: null,
      thirdList: [],
      colorList: [
        "#3AADF8",
        "#13FC97",
        "#F06C98",
        "#F29A76",
        "#53DDDB",
        "#7281E9",
      ],
    };
  },
  components: { Empty, BsBoxPanel },
  computed: {
    ...mapState(["companyId", "farmId"]),
    carouselItemLength() {
      return Math.ceil(this.sensorList.length / 6);
    },
  },
  created() {
    this.initMoudle();
  },
  methods: {
    async initMoudle() {
      this.loading = true;
      await this.getCameraListController(); //设备列表
      this.loading = false;
    },
    getMore() {
      location.href = `/index.html#/iot/newiot/company=${this.companyId}&farm=${this.farmId}`;
    },
    async getCameraListController() {
      try {
        const res = await iotAccess.deviceListService({
          farmId: this.farmId,
          pageNo: 1,
          pageSize: 200,
        });
        // console.log("res========>", res);
        if (res.list.length) {
          this.deviceId = res.list[0].deviceId;
          await this.getDetail(); //数据获取
        } else {
          await this.getThirdMarkerListService();
        }
      } catch (e) {
        console.log("e", e);
      }
    },
    async getDetail() {
      try {
        this.sensorList = [];
        const res = await iotAccess.deviceDetailService({
          farmId: this.farmId,
          deviceId: this.deviceId,
        });
        // let colorList = [
        //   "#3AADF8",
        //   "#13FC97",
        //   "#F06C98",
        //   "#F29A76",
        //   "#53DDDB",
        //   "#7281E9",
        // ];
        // console.log("res333", res);
        this.sensorList = res.sensorList;
        this.sensorList = res.sensorList.map((ele) => {
          return {
            metricIcon: ele.metricIcon,
            devicePropertyName: ele.devicePropertyName,
            value: ele.enumFlag ? ele.valueEnum : ele.value,
            unit: ele.unit,
            colorList: null,
          };
        });
      } catch (e) {
        console.log("e", e);
      }
    },
    // 获取第三方物联网设备列表
    async getThirdMarkerListService() {
      try {
        const res = await iotAccessThird.deviceListService({
          farmId: this.farmId,
          pageNo: 1,
          pageSize: 200,
        });
        if (res.list.length) {
          this.thirdID = res.list[0].deviceId;
          await this.getIotAccessThirdDeviceDetailService();
        } else {
          this.sensorList = [];
        }
      } catch (e) {
        console.log(e);
      }
    },

    // 获取第三方物联网设备详情
    async getIotAccessThirdDeviceDetailService() {
      try {
        this.sensorList = [];
        const res = await iotAccessThird.deviceGetDetailService({
          farmId: this.farmId,
          deviceId: this.thirdID,
        });
        this.sensorList = res.sensorList;
        this.sensorList = res.sensorList.map((ele) => {
          return {
            metricIcon: ele.icon,
            devicePropertyName: ele.name,
            value: ele.value,
            unit: ele.unit,
            colorList: "#4BB7FB",
          };
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@include bs(wrapper) {
  margin-top: 5px;
  @include utils-full-box();

  @include e(sensor) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    height: 100%;

    ::v-deep .el-carousel {
      height: 100%;
      width: 100%;
      .el-carousel__container {
        height: calc(100% - 26px);
        .el-carousel__item {
          box-sizing: border-box;
          padding: 8px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        }
      }
    }

    @include e(sensor-block) {
      display: flex;
      //flex-wrap: wrap;
      width: 46%;
      height: 33.33%;
      line-height: 1.3;
      align-items: center;
      margin-left: 10px;
      margin-bottom: 4px;
      padding: 10px 0 0 10px;
      background: url("~@/assets/images/farm/sensorList_bg.png") no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      @include e(img) {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
      @include e(div) {
        margin-left: 10px;
        width: 100%;
        font-size: 14px;
        color: #a1d0e2;
        @include e(div-name) {
          width: 88%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        @include e(div-unit) {
          font-size: 16px;
          color: #feeb48;
        }
      }
    }
  }
}
</style>
